import { Container, Box, useTheme, useMediaQuery } from '@mui/material';
import { Outlet, ScrollRestoration, useLocation } from 'react-router';
import CategoryHeader from '../Header/CategoryHeader';
import { useMemo } from 'react';
import { JaaRoute } from '../../utilities/Links';

export default function GeneralPageContainer() {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
  const location = useLocation();

  const isFrontPage = useMemo(() => {
    return location.pathname === JaaRoute.frontPage;
  }, [location]);

  return (
    <>
      {isFrontPage && isLargeScreen && <CategoryHeader />}
      <Container
        maxWidth='lg'
        disableGutters
        sx={{ paddingX: 2, flex: 1, paddingTop: { xs: 3, md: 6 } }}
      >
        <Box
          sx={{
            marginBottom: { xs: 6, md: 12 },
            gap: 48,
          }}
        >
          <ScrollRestoration />
          <Outlet />
        </Box>
      </Container>
    </>
  );
}
